const RecentInsightsTafsir=({recentInsightsArr})=>{
    const maxIndex=5;
    return(
        <>
            {
                recentInsightsArr.map((item,itemIndex)=>{
                    if(itemIndex<=maxIndex)
                    {
                        return(
                            <div key={itemIndex} className="mb-4 md:mb-0 recent-tile">
                                <a href={`/quran/tafsir/${item.type}/surah/${parseInt(item.surahNumber)}/?resume=${item.scrollPos}`}>
                                    <div className="blue-gr-box alim-interactive-tile">
                                        <p className="alim-font-color-style text-xs dark:text-opacity-75 mb-2 truncate">{item.titleMeaning}</p>
                                        <div className="grid grid-cols-2">
                                            <div className="col-span-1">
                                                <h5 className="alim-font-color-style text-xs font-medium">Surah {item.surahNumber}</h5>
                                            </div>
                                            <div className="col-span-1">
                                                <div className="text-right">
                                                    <h5 className="alim-font-color-style text-xs font-medium"> Juz {item.juz} </h5>
                                                </div>
                                            </div>
                                        </div>
                                        <h5 className="alim-font-color-style text-xs font-medium">{item.title}</h5>
                                        <div className="text-center py-4 px-2 mt-3 rounded recent-inner">
                                            <h5 className="text-base font-medium mb-1 font-extrabold">{item.arbTitle}</h5>
                                            <p className="text-opacity-75 text-xs font-medium">{item.type.toUpperCase()}</p>
                                        </div>
                                    </div>
                                </a>
                            </div> 
                        )
                    }
                })
            }
        </>
    )
}

export default RecentInsightsTafsir;